

const INITIAL_STATE = {
	user: null,
	token:null
}

const userReducers = (state = INITIAL_STATE, action = {}) => {
	switch (action.type) {
		case "UPDATE_USER":
			return {
				...state,
				user: action.user,
			};
		case "UPDATE_TOKEN":
			return {
				...state,
				token: action.token
			};
		default:
			return state;
	}
};

export default userReducers;